import { createFileRoute } from "@tanstack/react-router";
import { Newspaper, Quote } from "lucide-react";
import { SiteShell } from "@/components/site-shell";
import { pressMentions } from "@/data/sample";

export const Route = createFileRoute("/media")({
  head: () => ({
    meta: [
      { title: "Media & Press — Manavta" },
      { name: "description", content: "Press coverage and media mentions of Manavta." },
      { property: "og:title", content: "Media & Press — Manavta" },
      { property: "og:description", content: "What the press is saying about Manavta." },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <SiteShell>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[var(--saffron-deep)]">
          Media
        </p>
        <h1 className="mt-2 font-display text-4xl font-semibold text-[var(--maroon-deep)] sm:text-5xl">
          Media & press
        </h1>
        <p className="mt-3 max-w-2xl text-foreground/70">
          Journalists writing about Manavta are welcome to get in touch via the contact page. A
          detailed press kit — logo, board bios, mission statement and imagery — is available on
          request.
        </p>
        <div className="mt-8 rounded-2xl border border-dashed border-border bg-[var(--cream-2)] p-6 text-sm text-foreground/70">
          We haven't published a press-clippings archive yet. Below are the foundation's own guiding
          statements — the words we live by, in our own voice.
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-2">
          {pressMentions.map((p) => (
            <div
              key={p.name}
              className="rounded-2xl border border-border/60 bg-card p-6 shadow-[var(--shadow-soft)]"
            >
              <div className="flex items-center gap-3">
                <div className="grid h-10 w-10 place-items-center rounded-xl bg-[var(--cream-2)] text-[var(--maroon)]">
                  <Newspaper className="h-5 w-5" />
                </div>
                <p className="font-display text-lg font-semibold text-[var(--maroon-deep)]">
                  {p.name}
                </p>
              </div>
              <Quote className="mt-4 h-5 w-5 text-[var(--saffron-deep)]" />
              <p className="mt-2 text-sm leading-relaxed text-foreground/80">"{p.quote}"</p>
            </div>
          ))}
        </div>
      </section>
    </SiteShell>
  );
}
